export { default as createManyEventMutation } from './create-many-event-mutation';
export { default as createOneEventMutation } from './create-one-event-mutation';
export { default as eventFragment } from './event-fragment';
export { default as removeByIdEventMutation } from './remove-by-id-event-mutation';
export { default as updateByIdEventMutation } from './update-by-id-event-mutation';
export { default as updateEventDateTimeMutation } from './update-event-date-time-mutation';
